import { FireInputs, MajorPurchase } from './types';

let _id = 0;
const uid = () => String(++_id);

export const defaultPurchases: MajorPurchase[] = [
  { id: uid(), name: 'HDB BTO Flat', age: 30, lumpSum: 400000, recurringCost: 0, recurringYears: 0, repeatEveryYears: 0 },
  { id: uid(), name: 'Wedding', age: 30, lumpSum: 30000, recurringCost: 0, recurringYears: 0, repeatEveryYears: 0 },
  { id: uid(), name: 'First Child', age: 32, lumpSum: 20000, recurringCost: 15000, recurringYears: 20, repeatEveryYears: 0 },
  { id: uid(), name: 'Second Child', age: 34, lumpSum: 20000, recurringCost: 15000, recurringYears: 20, repeatEveryYears: 0 },
  { id: uid(), name: 'Car (COE + Purchase)', age: 30, lumpSum: 120000, recurringCost: 0, recurringYears: 0, repeatEveryYears: 10 },
  { id: uid(), name: "Parents' Retirement Support", age: 45, lumpSum: 0, recurringCost: 12000, recurringYears: 20, repeatEveryYears: 0 },
  { id: uid(), name: 'Home Renovation', age: 30, lumpSum: 60000, recurringCost: 0, recurringYears: 0, repeatEveryYears: 0 },
];

export const defaultInputs: FireInputs = {
  personal: {
    currentAge: 28,
    retirementAge: 55,
    lifeExpectancy: 85,
  },
  income: {
    annualIncome: 72000,
    annualExpenses: 36000,
    expenseItems: [],
    annualInvestmentContribution: 12000,
    salaryGrowthRate: 3,
    retirementExpenses: 48000,
    inflationRate: 2.5,
    withdrawalRate: 3.5,
  },
  assets: {
    cashSavings: 30000,
    investments: 50000,
    cashReturnRate: 1,
    investmentReturnRate: 7,
    investmentBuckets: [],
    retirementReturnReduction: 30,  // % — investments earn 30% less in retirement (more conservative)
  },
  policies: [],
  purchases: [],
  estatePlanning: {
    lpa: false,
    lpaDonee1: '',
    lpaDonee2: '',
    lpaReplacementDonee: '',
    will: false,
  },
  hospitalPlan: {
    hasMediShieldLife: true,
    hasISP: false,
    ispInsurer: '',
    ispWardClass: '',
    hasRider: false,
    annualPremiumMedisave: 0,
    annualPremiumCash: 0,
  },
};
